import { useEffect, useState } from "react";

export function Modal({
  isOpen,
  className,
  delay,
  children,
}: {
  isOpen: boolean;
  className?: string;
  delay: number;
  children: React.ReactNode;
}) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setTimeout(() => setOpen(isOpen), isOpen ? delay : 0);
  }, [delay, isOpen]);

  return (
    <div className={["react-modal", open && "open"].filter(Boolean).join(" ")}>
      <div className="react-modal__backdrop" />
      <div className={["react-modal__content", className].filter(Boolean).join(" ")}>
        {children}
      </div>
    </div>
  );
}
